// Shared rule for the brand-refresh presentational components' plain <a> tags: an absolute
// (http/https) href is leaving the shop — open it in a new tab so the shopper doesn't lose their
// place, e.g. the design.viewrail.com / glass.viewrail.com / treads.viewrail.com builders and any
// marketing-site link. A relative href is in-app navigation and stays in the same tab.
export const isExternalHref = (href: string) => /^https?:\/\//.test(href);

export const externalLinkProps = (href: string) =>
  isExternalHref(href) ? ({ target: '_blank', rel: 'noopener noreferrer' } as const) : {};
